// import React from 'react'
// import IMGLOGO from '../../assets/esports-mandir-mark-v2.png'
// import './spinner.css'

// const Spinner = () => {
//   return (
//     <div className="body">
//      {/* <div id="circle"> */}
//          <div id="square">
//             <img src={IMGLOGO} alt="IMGLOGO" />

//          </div>
//      </div>
     
//   )
// }

// export default Spinner





import React from 'react'
import './spinner.css'
import IMGLOGO from '../../assets/esports-mandir-mark-v2.png'

const Spinner = () => {
  return (
    //  Loading square for squar.red network
    <div className="loader-wrapper">
<span class="loader"><span class="loader-inner"></span></span>
<div className="img1"><img src={IMGLOGO} alt="IMGLOGO" /></div>
  </div>
  )
}

export default Spinner



// import React from 'react'
// import './spinner.css'
// import IMGLOGO from '../../assets/esports-mandir-mark-v2.png'

// const Spinner = () => {
//   return (
//     //  Loading square for squar.red network
//     <div className="loader-wrapper">
// <span class="loader"><span class="loader-inner"><img src={IMGLOGO} alt="IMGLOGO" /></span></span>

//   </div>
//   )
// }

// export default Spinner






// import React from 'react'
// import './spinner.css'

// const Spinner = () => {
//   return (
//     <div className="body">
//     <div id="circle">
//         <div id="square">

//         </div>
//     </div>
//     </div>
//   )
// }

// export default Spinner
